import { atom } from 'recoil';
import defaultTemplates from 'ProjectManager/Template/List/recoil/templates/defaultTemplates';

const templatesAtom = atom({
    key: 'projectManager_templatesList',
    default: defaultTemplates,
});

export default templatesAtom;
